<template>
    <v-container fluid style="margin: 60px 10%">
        <vueHeadful
        :title="this.$i18n.t('Menu.AdministracionPedidos') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12" align="center" class="mb-5">
                <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.PedidosPerfil')}}</h1>
            </v-col>
            <v-col cols="12">
                <v-data-table
                :headers="headerPedidos"
                :items="pedidos">
                    <template v-slot:[`item.productos`]="{ item }">
                        <span>{{item.productos.length}}</span>
                    </template>
                    <template v-slot:[`item.estado`]="{ item }">
                        <span v-if="item.estado === '4'">{{$t('Formularios.Aprobado')}}</span>
                        <span v-if="item.estado === '6'">{{$t('Formularios.Rechazado')}}</span>
                        <span v-if="item.estado === '7'">{{$t('Formularios.Pendiente')}}</span>
                    </template>
                    <template v-slot:[`item.acciones`]="{ item }">
                        <v-icon class="mx-2" color="black" @click="abrirPedido(item)">far fa-eye</v-icon>
                    </template>
                    <!-- <template v-slot:[`item.descargar`]="{ item }">
                        <v-icon class="mx-2" color="black" @click="abrirPedido(item)">fa-solid fa-download</v-icon>
                    </template> -->
                </v-data-table>
                <v-dialog v-model="dialog">
                    <v-card v-if="pedidoElegido">
                        <v-card-title>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" align="center" class="my-5">
                                        <h2>{{$t('Formularios.RevisarPedido')}}</h2>
                                        <br>
                                        <h3>{{pedidoElegido.uidPago}}</h3>
                                        <span class="font-weight-regular headline accent--text" v-if="pedidoElegido.estado === '4'">{{$t('Carrito.Aprobado')}}</span>
                                        <span class="font-weight-regular headline accent--text" v-if="pedidoElegido.estado === '6'">{{$t('Carrito.Rechazado')}}</span>
                                        <span class="font-weight-regular headline accent--text" v-if="pedidoElegido.estado === '7'">{{$t('Carrito.Pendiente')}}</span>
                                        <br>
                                        <span>{{pedidoElegido.fecha}}</span>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <v-icon v-if="pedidoElegido.esRegalo" size="46" color="primary">fas fa-gift</v-icon>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" class="px-5" align="center">
                                        <v-row>
                                            <v-col cols="12">
                                                <h2 class="font-weight-regular">{{$t('Formularios.Comprador')}}</h2>
                                            </v-col>
                                            <v-col cols="12" style="word-break:break-word;">
                                                <span>{{pedidoElegido.comprador.nombre}}</span>
                                                <br>
                                                <span>{{pedidoElegido.comprador.tipoDocumento}} {{pedidoElegido.comprador.documento}}</span>
                                                <br>
                                                <span>{{getPaises[pedidoElegido.comprador.pais - 1].name}} - {{pedidoElegido.comprador.departamento}} - {{pedidoElegido.comprador.ciudad}}</span>
                                                <br>
                                                <span>{{pedidoElegido.comprador.direccion}} - {{pedidoElegido.comprador.codigoPostal}}</span>
                                                <br>
                                                <span>{{pedidoElegido.comprador.email}}</span>
                                                <br>
                                                <span>{{pedidoElegido.comprador.telefono}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" class="px-5" align="center">
                                        <v-row>
                                            <v-col cols="12">
                                                <h2 class="font-weight-regular">{{$t('Formularios.DireccionEntrega')}}</h2>
                                            </v-col>
                                            <v-col cols="12" style="word-break:break-word;">
                                                <span>{{pedidoElegido.direccion.nombre}}</span>
                                                <br>
                                                <span>{{getPaises[pedidoElegido.direccion.pais - 1].name}} - {{pedidoElegido.direccion.departamento}} - {{pedidoElegido.direccion.ciudad}}</span>
                                                <br>
                                                <span>{{pedidoElegido.direccion.direccion}} - {{pedidoElegido.direccion.codigoPostal}}</span>
                                                <br>
                                                <span>{{pedidoElegido.direccion.telefono}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" align="center">
                                        <h2 class="font-weight-regular">{{$t('Carrito.Productos')}}</h2>
                                    </v-col>
                                    <v-col cols="12" v-for="i in pedidoElegido.productos" :key="i.uid">
                                        <v-card>
                                            <v-card-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="4" align-self="center">
                                                            <v-img :src="i.producto.imagenPrincipal" />
                                                        </v-col>
                                                        <v-col cols="8" align-self="center">
                                                            <span>{{i.producto.titulo}}</span>
                                                            <br>
                                                            <span><b>{{$t('Formularios.Cantidad')}}:</b> {{i.producto.cantidad}}</span>
                                                            <br>
                                                            <span><b>{{$t('Formularios.Tipo')}}:</b> {{i.producto.tipo}}</span>
                                                            <br>
                                                            <span><b>{{$t('Formularios.Precio')}}:</b> {{i.total.toLocaleString()}}</span>
                                                            <hr>
                                                            <span><b>{{$t('Formularios.Artista')}}</b></span>
                                                            <br>
                                                            <span>{{i.artista.nombre}}</span>
                                                            <br>
                                                            <span>{{i.artista.email}}</span>
                                                            <br>
                                                            <span>{{i.artista.pais}}</span>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                      <v-col cols="12" align="center" v-if="i.producto.tipo === 'fisico'">
                                                        <v-icon color="black" size="42" v-if="i.producto.enviado">fas fa-shipping-fast</v-icon>
                                                        <v-icon color="black" size="42" v-else>fas fa-box-open</v-icon>
                                                        <br>
                                                        <span class="font-weight-bold" v-if="i.producto.enviado">{{$t('Formularios.ProductoEnviado')}}</span>
                                                        <span class="font-weight-bold" v-else>{{$t('Formularios.ProductoEmpacando')}}</span>
                                                        <br>
                                                        <span v-if="i.producto.enviado">{{$t('Formularios.Guia')}}: {{i.producto.guia}}</span>
                                                        <br>
                                                        <span v-if="i.producto.enviado">{{$t('Formularios.Transportadora')}}: {{i.producto.transportadora}}</span>
                                                      </v-col>
                                                      <v-col cols="12" align="center" v-if="pedidoElegido.estado === '4' && i.producto.tipo === 'digital'">
                                                        <v-btn color="primary white--text" large :href="i.producto.archivoDigital" target="_blank">{{$t('Formularios.DescargarProducto')}}</v-btn>
                                                      </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-title>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-title>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
export default {
  name: 'PerfilPedidos',
  mounted () {
    firebase.firestore().collection('pedidos').where('comprador.uid', '==', this.getUsuario.uid).get().then(info => {
      let pedidos = []
      for (let i = 0; i < info.docs.length; i++) {
        pedidos.push(info.docs[i].data())
        if (i === (info.docs.length - 1)) {
          this.pedidos = Object.values(pedidos.reduce((result, {
            artista,
            comprador,
            direccion,
            esRegalo,
            estado,
            fecha,
            producto,
            total,
            uid,
            uidPago
          }) => {
            // Create new group
            if (!result[uidPago]) {
              result[uidPago] = {
                uidPago,
                comprador,
                direccion,
                esRegalo,
                estado,
                fecha,
                productos: []
              }
            }
            // Append to group
            result[uidPago].productos.push({
              uid,
              artista,
              producto,
              total
            })
            return result
          }, {}))
        }
      }
    })
  },
  data () {
    return {
      pedidos: [],
      headerPedidos: [
        { text: 'Código', value: 'uidPago' },
        { text: '# Productos', value: 'productos' },
        { text: 'Estado', value: 'estado' },
        { text: this.$i18n.t('Formularios.Ver'), value: 'acciones' }
      ],
      pedidoElegido: null,
      dialog: false
    }
  },
  methods: {
    abrirPedido (item) {
      this.pedidoElegido = item
      this.dialog = true
    }
  },
  computed: {
    ...mapGetters(['getPaises', 'getUsuario']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>

<style>
span {
  word-break:break-word;
}
</style>
